import { Select, Flex } from "@radix-ui/themes";
import { GlobeIcon } from "@radix-ui/react-icons";
import { useTranslation } from "react-i18next";

export function LanguageSelector() {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem("i18nextLng", value);
  };

  return (
    <Flex align="center" gap="2">
      <GlobeIcon width="14" height="14" color="var(--gray-9)" />
      <Select.Root
        value={i18n.language?.substring(0, 2) || "en"}
        onValueChange={handleLanguageChange}
        size="1"
      >
        <Select.Trigger variant="ghost" />
        <Select.Content>
          <Select.Item value="en">{t("userProfile.en")}</Select.Item>
          <Select.Item value="fr">{t("userProfile.fr")}</Select.Item>
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
